import React,{Component} from 'react';
import './UpdateEmail.css';

// redux
// import { connect } from 'react-redux';
// import _ from 'lodash';
// import classNames from 'classnames';

// REACT_TOOLS
// import User from '../../components/User/User';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { bannerImage } from '../../theme/images';

import { match } from 'react-router';
import UE from '@acri-tools/react-tools/components/_user_manager/UpdateEmail/UpdateEmail';


interface Props{
    match:match<{ token:string }>,
}


export default class UpdateEmail extends Component<Props,{}>{

    render(){
        return (
        <Page 
            id="update-email"
            title="Update email"
            banner={{
                topBar: true,
                bannerImage: bannerImage
            }}
            footer
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div"> 
                        <UE successRedirect={"/react-tools/components"} token={this.props.match.params.token}/>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

};
